import React from 'react';
import { Col, Row } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';
import OpsStatsTableHeaders from './OpsStatsTableHeaders';
import StatCol from './StatCol';

const OpsStats = () => {
    const opsStats = useSelector(getOpsStats, areStatsEqual);
    return (
        <OpsStatsTableHeaders>
            {(opsStats || []).map((o, x) => (
                <Col xs="12" key={o.accountId}>
                    <Row>
                        <StatCol xs='6'>
                            {o.firstName} {o.lastName}
                        </StatCol>
                        <StatCol xs='3'>
                            {o.assignedPracticesCount}
                        </StatCol>
                        <StatCol xs='3'>
                            {o.fixedPracticesCount}
                        </StatCol>
                    </Row>
                </Col>
            ))}
        </OpsStatsTableHeaders>
    );
};

const getOpsStats = (state)=>state.practice.dashboardInfo?.opsStats;

const areStatsEqual = (newStatsList, oldStatsList) => {

    if(oldStatsList.length !== newStatsList.length) return false;

    const statsEqualityCheck = (oldStat) => {
        const compareStats = (newStat) => {
            return shallowEqual(newStat, oldStat);
        };
        return newStatsList.some(compareStats);
    };

    const comparedStatList = !!oldStatsList.length && oldStatsList.every(statsEqualityCheck);

    const isSameStatList = !!newStatsList.length && comparedStatList;

    return isSameStatList;
};

export default OpsStats;
